import React, { useEffect, useState } from "react";
import type { DatePickerProps } from "antd";
import { DatePicker, Space } from "antd";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import ComponentLabel from "../../ControlComponents/ComponentLabel";
import { RangePickerProps } from "antd/lib/date-picker";
import { TableInputProps } from "../TableComponent/TableComponent";
import { getDateFormat } from "../../../Helper/FormatDateTime";
import { Form, Input } from "antd";
import { Store } from "antd/lib/form/interface";
import { IDateTemplate } from "../../../IRequestModel/ITemplateDescModel";
import useMasterSetting from "../../../hooks/useMasterSetting";
import { checkRequireFromTemplate } from "../../../Helper/RequestScreenHelper";
import locale from 'antd/es/date-picker/locale/th_TH';
import ThaiDatePicker from "./ThaiDatePickerControlComponent";
import customParseFormat from "dayjs/plugin/customParseFormat";

import dayjs from 'dayjs';
dayjs.extend(customParseFormat);

type InputDateProps = {
  ref?: any;
  template: IDateTemplate;
  value?: any;
  status?: any;
  onChange: (value: any) => void;
  canEditDoc: boolean;
  checkActionPage: string;
  actionAlert?: any;
  onControlChange?: (
    controlTemplate: any,
    controlValue: any,
    controlUpdate: any
  ) => any;
  layout: any;
};

type IDateControlProps = {
  template: IDateTemplate;
  data: any;
  rowIdx: number;
  colIdx: number;
  col?: any;
  colText?: number;
  colAction?: number;
  name: string;
  control: any;
  canEditDoc: boolean;
  checkActionPage: string;
  buttonType: string;
  actionAlert?: any;
  layout?: any;
  onControlChange: (
    controlTemplate: any,
    controlValue: any,
    oldControlValue: any
  ) => any;
};

const DateInputComponent: React.FC<InputDateProps> = ({
  ref,
  template,
  value,
  status,
  onChange,
  canEditDoc,
  checkActionPage,
  actionAlert,
  onControlChange,
  layout,
  ...props
}) => {

  const [action, setAction] = useState<boolean>(false);
  const { masterSetting } = useMasterSetting();
  const format = masterSetting["FormatDate"]?.Value2 || "";
  const buddhistFormat = format.replace(/dd/i, "DD").replace(/yyyy/i, "BBBB");
  const finalDate = buddhistFormat.replaceAll(" ", "/");
  const displayFormatForThaiDate = String(template?.attribute?.displayFormat ?? "").replaceAll("y", "B").toUpperCase();
  const masterDataFormatForThaiDate = String(masterSetting?.["FormatDate"]?.Value2 ?? "").toLowerCase().replaceAll("y", "B").toUpperCase();

  const datePickerTh = {
    ...locale,
    lang: {
      ...locale.lang,
      yearFormat: 'BBBB',
      dateFormat: 'M/D/BBBB',
      dateTimeFormat: 'M/D/BBBB HH:mm:ss',
    },
    dateFormat: 'BBBB-MM-DD',
    dateTimeFormat: 'BBBB-MM-DD HH:mm:ss',
    weekFormat: 'BBBB-wo',
    monthFormat: 'BBBB-MM',
  };

  useEffect(() => {
    checkStatus();
  }, [action]);

  const checkStatus = () => {
    if (actionAlert) {
      if (actionAlert.Data) {
        actionAlert.Data.map((data: any) => {
          if (
            actionAlert.ErrorType === "SpecialError" &&
            data.Label === template.label &&
            data.Value === value
          ) {
            setAction(true);
          } else {
            setAction(false);
          }
        });
      }
    }
  };
  function formatDate(date: string) {
    let arrDate = date.split("/");

    const mm = Number(arrDate[1]);
    if (mm === 1) {
      arrDate[1] = "Jan";
    } else if (mm === 2) {
      arrDate[1] = "Feb";
    } else if (mm === 3) {
      arrDate[1] = "Mar";
    } else if (mm === 4) {
      arrDate[1] = "Apr";
    } else if (mm === 5) {
      arrDate[1] = "May";
    } else if (mm === 6) {
      arrDate[1] = "Jun";
    } else if (mm === 7) {
      arrDate[1] = "Jul";
    } else if (mm === 8) {
      arrDate[1] = "Aug";
    } else if (mm === 9) {
      arrDate[1] = "Sep";
    } else if (mm === 10) {
      arrDate[1] = "Oct";
    } else if (mm === 11) {
      arrDate[1] = "Nov";
    } else if (mm === 12) {
      arrDate[1] = "Dec";
    }
    return arrDate.join(
      template.attribute.date.symbol !== ""
        ? template.attribute.date.symbol
        : "/"
    );
  }
  const getDateValue = (dateValue: any) => {
    // let newDate: Date = new Date();
    let newDate = moment(
      moment(new Date(dateValue)).format("DD MMM YYYY"),
      "DD MMM YYYY"
    ).toDate();

    if (newDate.toString().toLowerCase() === "invalid date") {
      newDate = moment(formatDate(dateValue), "DD MMM YYYY").toDate();
    } else {
      newDate = moment(
        moment(formatDate(dateValue)).format("DD MMM YYYY"),
        "DD MMM YYYY"
      ).toDate();
      if (newDate.toString().toLowerCase() === "invalid date") {
        console.log("cal=>props.data.value", dateValue);
      }
    }

    // return newDate;
    return moment(
      new Date(newDate).toLocaleString("en-UK", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
      getDateFormat(template.attribute)
    );
  };

  const buddhistToGregorian = (buddhistYear: any) => {
    return buddhistYear - 543;
  };

  const gregorianToBuddhist = (gregorianYear: number) => {
    return gregorianYear + 543;
  };

  const getDateValueForThaiDatePicker = (dateValue: any) => {
    if (!dateValue || dateValue ==="Invalid date") return null;

    const monthMap = {
      "ม.ค.": "Jan",
      "ก.พ.": "Feb",
      "มี.ค.": "Mar",
      "เม.ย.": "Apr",
      "พ.ค.": "May",
      "มิ.ย.": "Jun",
      "ก.ค.": "Jul",
      "ส.ค.": "Aug",
      "ก.ย.": "Sep",
      "ต.ค.": "Oct",
      "พ.ย.": "Nov",
      "ธ.ค.": "Dec",
    };

    if (dayjs.isDayjs(dateValue)) return dateValue;

    const englishPattern = /^\d{1,2} [A-Za-z]{3} \d{4}$/;
    if (englishPattern.test(dateValue)) {
      const [day, month, year] = dateValue.split(" ");
      const buddhistYear = gregorianToBuddhist(parseInt(year));
      dateValue = `${day}/${month}/${buddhistYear}`;
    }

    Object.entries(monthMap).forEach(([thai, eng]) => {
      if (dateValue.includes(thai)) {
        dateValue = dateValue.replace(thai, eng);
      }
    });

    const [day, month, buddhistYear] = dateValue.split("/");
    const gregorianYear = buddhistToGregorian(parseInt(buddhistYear));
    const convertedDate = `${day}/${month}/${gregorianYear}`;

    const parsed = dayjs(convertedDate, "DD/MMM/YYYY", true).locale("th");

    if (!parsed.isValid()) {
      console.log("วันที่มีปัญหา:", dateValue);

      let [day, monthTh, yearStr] = dateValue.split(" ");
      Object.entries(monthMap).forEach(([thai, eng]) => {
        if (dateValue.includes(thai)) {
          dateValue = dateValue.replace(thai, eng);
        }
      });

      let year = parseInt(yearStr);
      const formattedDate = `${day}/${monthTh}/${year}`;
      console.log("มีปัญหาหาเรื่องการแปลงวันที่:", formattedDate);

      const parsedThai = dayjs(formattedDate, "DD/MMM/YYYY", true).locale("th");
      return parsedThai.isValid() ? parsedThai : null;
    }
    return parsed;
  };

  return (
    <>
      {layout?.template?.attribute?.buddhismFormat === "Y" || template.attribute.buddhismFormat === "Y" ?
        <>
          <ThaiDatePicker
            ref={ref}
            id={template.label}
            value={getDateValueForThaiDatePicker(value)}
            disabled={!canEditDoc || template.attribute.readonly === "Y"}
            locale={datePickerTh}
            format={displayFormatForThaiDate ? 
              displayFormatForThaiDate : masterDataFormatForThaiDate ? 
              masterDataFormatForThaiDate : getDateFormat(template.attribute, "thai")
            }
            onChange={(value) => {
              if (value && dayjs(value).isValid()) {
                onChange(value.format(getDateFormat(template.attribute, "thai")));
              } else {
                onChange("");
              }
            }}
            status={action ? "error" : ""}
            inputReadOnly
          />
        </> :
        <>
          <DatePicker
            disabled={!canEditDoc || template.attribute.readonly === "Y"}
            ref={ref}
            id={template.label}
            size={"large"}
            value={value && getDateValue(value)}
            format={
              template.attribute.displayFormat
                ? template.attribute.displayFormat
                : masterSetting["FormatDate"]?.Value2
                  ? masterSetting["FormatDate"]?.Value2
                  : getDateFormat(template.attribute)
            }
            showTime={
              template.attribute.time.use === "Y"
                ? { defaultValue: moment("00:00:00", "HH:mm:ss") }
                : false
            }
            onChange={(value) => {
              onChange(
                value ? value?.format(getDateFormat(template.attribute)) : ""
              );
            }}
            status={action ? "error" : ""}
            inputReadOnly
          />
        </>
      }
    </>
  );
};
// this one row col index
export const DatePickerControlComponent: React.FC<IDateControlProps> = ({
  colIdx,
  rowIdx,
  control,
  name,
  data,
  template,
  col,
  colAction,
  colText,
  canEditDoc,
  checkActionPage,
  buttonType,
  onControlChange,
  layout,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: canEditDoc && checkRequireFromTemplate(template, buttonType) && `${template.label}`,
      }}
      render={({
        field: { onChange, value, onBlur, name, ref },
        formState: { errors, isSubmitted },
      }) => (
        <>
          <ComponentLabel
            col={col}
            colText={colText}
            rowIdx={rowIdx}
            colIdx={rowIdx}
            template={template}
          />
          <Col
            sm={col === undefined ? 12 : 12}
            md={col === undefined ? colAction : 12}
            xs={col === undefined ? 12 : 12}
            xl={col === undefined ? colAction : 12}
            className={"padding-controller"}
          >
            <div
              className={`input-component-container  ${isSubmitted &&
                errors?.items &&
                errors?.items[rowIdx] &&
                errors?.items[rowIdx].layout[colIdx]
                ? "set-layout-required"
                : ""
                }`}
            >
              <DateInputComponent
                {...{ canEditDoc, checkActionPage }}
                layout={layout}
                template={template}
                value={value}
                status={
                  isSubmitted &&
                  errors?.items &&
                  errors?.items[rowIdx] &&
                  errors?.items[rowIdx].layout[colIdx] &&
                  "error"
                }
                onChange={(value) => {
                  onChange(value);
                  onControlChange(template, value, data);
                }}
              />

              {isSubmitted &&
                errors?.items &&
                errors?.items[rowIdx] &&
                errors?.items[rowIdx].layout[colIdx] && (
                  <small id="Name-help" className="p-error p-d-block">
                    {template.label} is required.
                  </small>
                )}
            </div>
          </Col>
        </>
      )}
    />
  );
};

export const DatePickerTableComponent: React.FC<TableInputProps> = ({
  name,
  template,
  saveFunc,
  inputRef,
  isEditing,
  onEdit,
  children,
  canEditDoc,
  checkActionPage,
  buttonType,
  layout,
  ...props
}) => {
  if (!isEditing) {
    return (
      <div onMouseOver={onEdit}>
        <DateInputComponent
          {...{ canEditDoc, checkActionPage }}
          ref={inputRef}
          value={children[1]}
          template={template}
          onChange={saveFunc}
          layout={layout}
        />
      </div>
    );
  }
  return (
    <>
      <Form.Item
        style={{ margin: 0 }}
        name={name}
        // normalize={(value: any, prevValue: any, allValues: Store) => {
        //   if (value !== "" && value !== undefined) {
        //     return moment(value, getDateFormat(template.attribute));
        //   } else {
        //     return null;
        //   }
        // }}
        rules={[
          {
            required:
              template.attribute.require === "Y" &&
              checkRequireFromTemplate(template, buttonType),
            message: `${template.label} is required.`,
          },
        ]}
      >
        <DateInputComponent
          {...{ canEditDoc, checkActionPage }}
          ref={inputRef}
          template={template}
          onChange={(e: any) => {
            saveFunc(template.type, template.type);
          }}
          layout={layout}
        />
      </Form.Item>
    </>
  );
};
